<template>
  <div :class='{
    "w-full": isGD
  }'>
    <vue-autosuggest ref="autosuggest" v-model="value.name" :class="{ 'gp-autosuggest': isGD }" :suggestions="suggestions"
      :render-suggestion="renderSuggestion" :get-suggestion-value="getSuggestionValue" :input-props="inputProps"
      @focus="onInputChange('')" @input="onInputChange" @selected="onSelected">
      <template slot-scope="{ suggestion }">
        <div><b>{{ suggestion.item.name }}</b></div>
      </template>
    </vue-autosuggest>
  </div>
</template>

<script>
import api from '@groovepages/gd-lib/api';
import auth from '@groovepages/gd-lib/auth';
import Axios from 'axios';
import { VueAutosuggest } from "vue-autosuggest";

export default {
  name: 'GdAutosuggest',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    isGD: {
      type: Boolean,
      default: false
    },
    gdType: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default() {
        return {
          name: ''
        };
      }
    }
  },
  components: {
    VueAutosuggest
  },
  data() {
    return {
      options: [],
      suggestions: []
    };
  },
  async created() {
    if (this.isGD && this.gdType === 'Video') {
      this.options = await api.get(`${window.gdEnv.VUE_APP_API_URL}/groovevideo/videos`)
        .then(data => data.data);
    }
    else if (this.isGD && this.gdType === 'Blog') {
      this.suggestions = await api.post(`${window.gdEnv.VUE_APP_API_URL}/grooveblog/blog/search`, {
        name: ''
      })
        .then(data => [
          {
            data: data.data
          }
        ]);
    }
    else if (this.isGD && this.gdType === 'Kart') {
      const loggedInUser = auth.authenticatedUser();
      this.options = await Axios({
        method: 'post',
        url: 'https://sample.groovekart.com/mobile-api/api.php',
        transformRequest: [(data, headers) => {
          delete headers.common;
          return data;
        }],
        data: JSON.stringify({
          'request_type': 'list_stores',
          'token': loggedInUser.token,
          'token_type': loggedInUser.auth_keycloak ? 'keycloak' : 'auth0',
        })
      })
        .then(data => data.data.stores_list);
    }
  },
  computed: {
    inputProps() {
      return {
        id: 'autosuggest__input',
        placeholder: this.placeholder,
        disabled: this.loading,
        class: this.classes ? this.classes : ''
      };
    }
  },
  methods: {
    renderSuggestion(suggestion) {
      return suggestion.item.name;
    },

    getSuggestionValue(suggestion) {
      return suggestion.item.name;
    },

    onSelected(item) {
      if (this.isGD && this.gdType === 'Video') {
        this.$emit('change', item.item);
      }
      else if (this.isGD && (this.gdType === 'Blog' || this.gdType === 'Kart')) {
        this.$emit('change', item.item);
      }
      else {
        this.$emit('onSelected', item);
      }
    },

    async onInputChange(text) {
      if (this.isGD && this.gdType === 'Video') {
        this.$emit('input', { name: text });
        const regexp = new RegExp(text, 'i');
        this.suggestions = this.options.length ? [
          {
            data: this.options.filter(item => {
              return item.name.search(regexp) > -1;
            })
          }
        ] : [];
      }
      else if (this.isGD && this.gdType === 'Blog') {
        this.$emit('input', { name: text });
        this.suggestions = await api.post(`${window.gdEnv.VUE_APP_API_URL}/grooveblog/blog/search`, {
          name: text
        })
          .then(data => {
            return [
              {
                data: data.data.map(data => { return { "name": data.name, "published_url": data.published_url, "blog_url": data.published_url ?? data.blog_url } })
              }
            ]
          });
      }
      else if (this.isGD && this.gdType === 'Kart') {
        this.$emit('input', { name: text });
        const regexp = new RegExp(text, 'i');
        this.suggestions = this.options.length ? [{
          data: []
        }] : [];
        this.options.map(item => {
          const name = item.store_title !== 'Null' ? item.store_title : item.store_name.split('.groovekart.com')[0];
          if (name.search(regexp) > -1) {
            this.suggestions[0].data.push({
              name,
              store_name: item.store_name,
              store_title: item.store_title,
            });
          }
        });
      }
      else {
        this.$emit('onInputChange', text);
      }
    }
  }
};
</script>

<style>
#autosuggest__input.autosuggest__input--open {
  border-bottom: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: var(--brand-secondary-light, #545671);
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  background: var(--brand-secondary, #292b49);
  padding: 0px;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding-left: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--brand-secondary-invert, #efeff5);
}

#autosuggest ul:nth-child(1)>.autosuggest__results_title {
  border-top: none;
}

.autosuggest__results {
  overflow: auto;
}

.autosuggest__results {
  max-height: 300px;
}

.autosuggest__results .autosuggest__results_title {
  color: var(--brand-secondary-lighter, gray);
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid var(--brand-secondary-lightest, lightgray);
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: var(--brand-secondary-darker, #191c3c);
}

.gp-autosuggest div[aria-owns="autosuggest-autosuggest__results"] {
  position: relative;
}

.gp-autosuggest div[aria-owns="autosuggest-autosuggest__results"]:after {
  content: "";
  position: absolute;
  border: solid var(--brand-secondary-lightest, #a4a8c0);
  border-width: 0 3px 3px 0;
  border-radius: 2px;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  top: 9px;
  right: 11px;
}
</style>